import React from "react";
import ReactDOM from "react-dom";

function FilePreviewModal({ fileURL, onClose, type }) {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999999]">
      <div className="flex flex-col gap-y-2 w-auto py-4 items-center rounded-7 bg-white">
        <h1 className="text-xl">File Preview</h1>
        <div className="bg-neutral-100 border-4 border-[#f7df44] w-[700px] flex items-center justify-center relative overflow-hidden">
          {fileURL && type === "pdf" ? (
            <iframe
              src={fileURL}
              title="PDF Preview"
              width="100%"
              height="500px"
            ></iframe>
          ) : (
            <img src={fileURL} alt="Preview" width="100%" height="500px" />
          )}
        </div>
        <button
          className="text-white bg-blue-700 hover:bg-blue-900 focus:outline-none focus:ring-4 focus:ring-offset-2 focus:ring-blue-500 py-2 px-4 rounded-md"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>,
    document.body
  );
}

export default FilePreviewModal;
